import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  AnyApiFactory,
  configApiRef,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';
import { techRadarApiRef } from '@backstage-community/plugin-tech-radar';
import { MockTechRadarClient } from './lib/MockTechRadarClient';
import { TechRadarClient } from './lib/TechRadarClient';
import {
  ApiDefinitionWidget,
  apiDocsConfigRef,
  defaultDefinitionWidgets,
} from '@backstage/plugin-api-docs';
import { ApiEntity } from '@backstage/catalog-model';
import React from 'react';
import { CustomAsyncApiDefinitionWidget } from '@internal/backstage-plugin-vorwerk';
import { scaffolderApiRef, ScaffolderClient} from "@backstage/plugin-scaffolder";

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scaffolderApiRef,
    deps: {
      discoveryApi: discoveryApiRef,
      identityApi: identityApiRef,
      scmIntegrationsApi: scmIntegrationsApiRef,
      fetchApi: fetchApiRef,
    },
    factory: ({ scmIntegrationsApi, discoveryApi, identityApi, fetchApi }) =>
      new ScaffolderClient({
        discoveryApi,
        identityApi,
        scmIntegrationsApi,
        fetchApi,
        // Enabling long polling is a workaround for event stream protocol errors:
        // https://github.com/backstage/backstage/issues/5535 and https://github.com/backstage/backstage/pull/13961/files
        // These errors happen when we run our software template on the raider instance - it does not happen locally.
        useLongPollingLogs: true,
      }),
  }),
  createApiFactory({
    api: apiDocsConfigRef,
    deps: {},
    factory: () => {
      const definitionWidgets = defaultDefinitionWidgets();
      return {
        getApiDefinitionWidget: (apiEntity: ApiEntity) => {
          if (apiEntity.spec.type === 'asyncapi') {
            return {
              type: 'asyncapi',
              title: 'AsyncAPI',
              rawLanguage: 'yaml',
              component: (definition: string) => (
                <CustomAsyncApiDefinitionWidget definition={definition} />
              ),
            } as ApiDefinitionWidget;
          }

          // fallback to the defaults
          return definitionWidgets.find(d => d.type === apiEntity.spec.type);
        },
      };
    },
  }),
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  ScmAuth.createDefaultApiFactory(),
  createApiFactory({
    api: techRadarApiRef,
    deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
    factory: ({ discoveryApi, fetchApi }) =>
      process.env.NODE_ENV === 'development'
        ? new MockTechRadarClient()
        : new TechRadarClient({ discoveryApi, fetchApi }),
  }),
];
